import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const PaddingWrapper = styled.div`
  padding: 50px 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 100px;
  padding-left: 30%;
  ${mediaQuery('tablet')} {
    padding-top: 0;
    padding-left: 0;
  }
`;

export const BlueCard = styled.div`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding-top: 40px;
  padding-left: 100px;
  padding-right: 60px;
  background: ${(props) => props.theme.color.blue.lightBlue};
  color: ${(props) => props.theme.color.blue.default};
  height: 70%;
  max-height: 400px;
  width: 40%;
  left: 0;
  top: 0;
  z-index: -1;
  position: absolute;
  ${mediaQuery('medium')} {
    padding-left: 60px;
  }
  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const PurpleCardTitle = styled.div`
  ${responsiveFontSize(42, 3)};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  max-width: 220px;
`;

export const WhiteCard = styled.div`
  text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) => props.theme.color.purple.default};
  padding: 30px;
  ${mediaQuery('small')} {
    padding: 0px;
    box-shadow: none;
  }
`;

export const WhiteCardTitle = styled(PurpleCardTitle)`
  max-width: none;
  text-align: center;
  margin-bottom: 15px;
  ${mediaQuery('tablet', 'min')} {
    display: none;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 30px;
  ${mediaQuery('small')} {
    padding: 0px;
  }
`;

export const ItemWrapper = styled.div`
  margin-bottom: 30px;
  width: ${100 / 3}%;
  ${mediaQuery('tablet')} {
    width: 50%;
  }
`;

export const ItemImage = styled.img`
  max-height: 70px;
  max-width: 140px;
  ${mediaQuery('small')} {
    width: 80%;
    height: auto;
    object-fit: contain;
  }
`;
